import React from 'react';
import PropTypes from 'prop-types';
import graphql from 'graphql';
import Link from 'gatsby-link';

// find a post title by path
const findNode = (path, data) =>
  data.allMarkdownRemark.edges
    .map(edge => edge.node.frontmatter)
    .filter(r => r.path === path)
    .pop();

export default function Template({ data }) {
  const { markdownRemark: post } = data;
  const related = post.frontmatter.related ? post.frontmatter.related.map(r => findNode(r.post, data)) : [];
  return (
    <article className="blog-article">
      <h1 className="blog-title is-size-3">Introduction to Gatsby</h1>
      <div dangerouslySetInnerHTML={{ __html: post.html }} />
      {post.frontmatter.related && (
        <div>
          <h4>Related</h4>
          <div>
            {related.map((r, i) => (
              <article key={i} className="blog-card">
                <a href="/blog/2017-05-31-introduction-to-gatsby/">
                  <h2>Introduction to Gatsby</h2>
                  <p className="blog-card-summary">In case you haven’t heard about it, Gatsby is the latest hot thing in static site generators</p>
                </a>
                <div className="css-12lx5dg">
                  <div className="gatsby-image-outer-wrapper" style={{ position: 'relative' }}>
                    <div
                      className="css-h0bc48 gatsby-image-wrapper"
                      style={{ position: 'relative', overflow: 'hidden', display: 'inline-block', width: 30, height: 30 }}>
                      <img
                        alt
                        width={30}
                        height={30}
                        src="/static/michelle-barker-0b8a1fc61532e5bdd544b3b126f0376a-03a46.jpg"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          transition: 'opacity 0.5s',
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center center',
                          opacity: 1,
                        }}
                      />
                    </div>
                  </div>
                  <div className="css-1x81eig">
                    <div>
                      <a className="css-id30rn" href="/contributors/michelle-barker/">
                        Michelle Barker
                      </a>{' '}
                      on May 31st 2018
                    </div>
                  </div>
                </div>
                <Link to={r.path}>{r.title}</Link>
              </article>
            ))}
          </div>
        </div>
      )}
    </article>
  );
}

Template.propTypes = {
  data: PropTypes.object,
};

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        date(formatString: "MMMM DD, YYYY")
        title
        author
        postimage
      }
    }
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          frontmatter {
            contentType
            title
            path
            postimage
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/template-blog-post.js